<table>
    <thead>
        <tr>
            <th>{{'gestionLicencias.parametros.table.tabs.grupoEtiquetasMarca.marca' | translate}}</th>
            <th>{{'gestionLicencias.parametros.table.tabs.grupoEtiquetasMarca.caja' | translate}}</th>
            <th>{{'gestionLicencias.parametros.table.tabs.grupoEtiquetasMarca.pallet' | translate}}</th>
            <th class="actions">{{'gestionLicencias.parametros.table.tabs.grupoEtiquetasMarca.acciones' | translate}}</th>
        </tr>
    </thead>
    <tbody>
        <app-new-edit-param-grupo-etiquetas-marca class="component-in-row" *ngFor="let marca of marcas" [editable]="editable" [grupoEtiquetasCaja]="grupoEtiquetasCaja"
        [denominacionId]="denominacionId" [almacenId]="almacenId" [licenciaSwId]="licenciaSwId" [grupoEtiquetasPallet]="grupoEtiquetasPallet" (refresh)="toRefresh($event)" (editableChanged)="editableChanged($event)" [marcaId]="marca.idMarca"
        [marca]="marca.desMarca"(pushMessage)="pushMessage.emit($event)"></app-new-edit-param-grupo-etiquetas-marca> 
    </tbody>
    <tfoot *ngIf="(!grupoEtiquetasCaja || grupoEtiquetasCaja.length < 1) || (!grupoEtiquetasPallet || grupoEtiquetasPallet.length < 1) ">
        <tr>
            <td colspan="6">
                {{ 'global.noContent' | translate }}
            </td>
        </tr>
    </tfoot>
</table>